var _defs, _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack615({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M5.13,11.78V3.91H11V5.24H6.72V7h4V8.31H6.72v2.15h4.4v1.32Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 1,
    y: 1,
    width: 14,
    height: 14
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack615);
export default __webpack_public_path__ + "static/media/Symbolpack_6_15.5422d08b9499cb7ea07e74b2db9b44f7.svg";
export { ForwardRef as ReactComponent };